import { mediaMax } from '@/app/styles/breakpoints'
import { Icon } from '@/shared/ui/Icon/Icon'
import { Flex, Typography } from 'antd'
import styled from 'styled-components'

export const AccountsSection = styled(Flex)`
  && {
    .ReactVirtualized__Grid {
      overflow: hidden !important;
    }
  }
`

export const SelectedData = styled(Flex)`
  padding: 16px;
  background-color: ${(props) => props.theme.colors.alert.success.bg};
  border: 1px solid ${(props) => props.theme.colors.alert.success.border};
  border-radius: 6px;
`

export const SelectedCheck = styled(Icon)`
  fill: ${(props) => props.theme.colors.success};
  flex: 0 0 auto;
`

export const SelectedInfo = styled(Flex)`
  gap: 16px;
  ${mediaMax.md} {
    gap: 8px;
  }
`

export const SelectedOptions = styled(Flex)``

export const SelectedOption = styled(Flex)``

export const SelectedOptionLabel = styled(Typography.Text)`
  color: ${(props) => props.theme.colors.textLight};
`
